import { render, staticRenderFns } from "./new-detail.vue?vue&type=template&id=a498c80c&scoped=true&"
import script from "./new-detail.vue?vue&type=script&lang=js&"
export * from "./new-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-detail.vue?vue&type=style&index=0&id=a498c80c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a498c80c",
  null
  
)

export default component.exports